import { render, staticRenderFns } from "./AliPayButton.vue?vue&type=template&id=9c6bf0b4&scoped=true"
import script from "./AliPayButton.vue?vue&type=script&lang=ts"
export * from "./AliPayButton.vue?vue&type=script&lang=ts"
import style0 from "./AliPayButton.vue?vue&type=style&index=0&id=9c6bf0b4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6bf0b4",
  null
  
)

export default component.exports